/* eslint-disable react/jsx-props-no-spreading */
import { useState } from 'react';
import { Alert } from 'react-bootstrap';

export const DismissibleAlert = ({ message, ...props }) => {
  const [show, setShow] = useState(true);
  if (!show) {
    return null;
  }
  return (
    <Alert
      variant="success"
      onClose={() => setShow(false)}
      dismissible
      {...props}
    >
      {message}
    </Alert>
  );
};
